var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10, _image, _image2, _image3, _image4, _image5, _image6, _image7, _image8, _image9, _mask, _mask2, _mask3, _mask4, _mask5, _mask6, _mask7, _mask8, _mask9, _g, _filter, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGooglePlay = function SvgGooglePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 188,
    height: 56
  }, props), /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "googlePlay_svg__H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h188v55.828H0Zm0 0"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "googlePlay_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h188v56H0z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "googlePlay_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h188v56H0z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "googlePlay_svg__h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h188v56H0z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "googlePlay_svg__j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h188v56H0z"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "googlePlay_svg__l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h188v56H0z"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "googlePlay_svg__n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h188v56H0z"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "googlePlay_svg__p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h188v56H0z"
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "googlePlay_svg__q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h188v56H0z"
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "googlePlay_svg__G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h188v56H0z"
  }))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALwAAAA4CAYAAABHaJJlAAAABmJLR0QA/wD/AP+gvaeTAAAAvElEQVR4nO3SSRGAMADAwHL4V4At3DBTXLSP7CrII8f8rjkg4twdACsZnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJucd83t0RsMoPKWgF3+ZcfFwAAAAASUVORK5CYII=",
    id: "googlePlay_svg__b",
    width: 188,
    height: 56
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALwAAAA4CAYAAABHaJJlAAAABmJLR0QA/wD/AP+gvaeTAAAAvElEQVR4nO3SSRGAMADAwHL4V4At3DBTXLSP7CrII8f8rjkg4twdACsZnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJucd83t0RsMoPKWgF3+ZcfFwAAAAASUVORK5CYII=",
    id: "googlePlay_svg__c",
    width: 188,
    height: 56
  })), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALwAAAA4CAYAAABHaJJlAAAABmJLR0QA/wD/AP+gvaeTAAAAvElEQVR4nO3SSRGAMADAwHL4V4At3DBTXLSP7CrII8f8rjkg4twdACsZnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJucd83t0RsMoPKWgF3+ZcfFwAAAAASUVORK5CYII=",
    id: "googlePlay_svg__e",
    width: 188,
    height: 56
  })), _image4 || (_image4 = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALwAAAA4CAYAAABHaJJlAAAABmJLR0QA/wD/AP+gvaeTAAAAvElEQVR4nO3SSRGAMADAwHL4V4At3DBTXLSP7CrII8f8rjkg4twdACsZnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJucd83t0RsMoPKWgF3+ZcfFwAAAAASUVORK5CYII=",
    id: "googlePlay_svg__g",
    width: 188,
    height: 56
  })), _image5 || (_image5 = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALwAAAA4CAYAAABHaJJlAAAABmJLR0QA/wD/AP+gvaeTAAAAvElEQVR4nO3SSRGAMADAwHL4V4At3DBTXLSP7CrII8f8rjkg4twdACsZnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJucd83t0RsMoPKWgF3+ZcfFwAAAAASUVORK5CYII=",
    id: "googlePlay_svg__i",
    width: 188,
    height: 56
  })), _image6 || (_image6 = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALwAAAA4CAYAAABHaJJlAAAABmJLR0QA/wD/AP+gvaeTAAAAvElEQVR4nO3SSRGAMADAwHL4V4At3DBTXLSP7CrII8f8rjkg4twdACsZnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJucd83t0RsMoPKWgF3+ZcfFwAAAAASUVORK5CYII=",
    id: "googlePlay_svg__k",
    width: 188,
    height: 56
  })), _image7 || (_image7 = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALwAAAA4CAYAAABHaJJlAAAABmJLR0QA/wD/AP+gvaeTAAAAvElEQVR4nO3SSRGAMADAwHL4V4At3DBTXLSP7CrII8f8rjkg4twdACsZnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJucd83t0RsMoPKWgF3+ZcfFwAAAAASUVORK5CYII=",
    id: "googlePlay_svg__m",
    width: 188,
    height: 56
  })), _image8 || (_image8 = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALwAAAA4CAYAAABHaJJlAAAABmJLR0QA/wD/AP+gvaeTAAAAvElEQVR4nO3SSRGAMADAwHL4V4At3DBTXLSP7CrII8f8rjkg4twdACsZnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJucd83t0RsMoPKWgF3+ZcfFwAAAAASUVORK5CYII=",
    id: "googlePlay_svg__o",
    width: 188,
    height: 56
  })), _image9 || (_image9 = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALwAAAA4CAYAAABHaJJlAAAABmJLR0QA/wD/AP+gvaeTAAAAvElEQVR4nO3SSRGAMADAwHL4V4At3DBTXLSP7CrII8f8rjkg4twdACsZnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJMTwphifF8KQYnhTDk2J4UgxPiuFJucd83t0RsMoPKWgF3+ZcfFwAAAAASUVORK5CYII=",
    id: "googlePlay_svg__F",
    width: 188,
    height: 56
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "googlePlay_svg__J"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#googlePlay_svg__a)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#googlePlay_svg__b"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "googlePlay_svg__s"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#googlePlay_svg__a)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#googlePlay_svg__c"
  })))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "googlePlay_svg__u"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#googlePlay_svg__a)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#googlePlay_svg__e"
  })))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "googlePlay_svg__w"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#googlePlay_svg__a)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#googlePlay_svg__g"
  })))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "googlePlay_svg__y"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#googlePlay_svg__a)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#googlePlay_svg__i"
  })))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "googlePlay_svg__A"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#googlePlay_svg__a)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#googlePlay_svg__k"
  })))), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "googlePlay_svg__C"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#googlePlay_svg__a)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#googlePlay_svg__m"
  })))), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "googlePlay_svg__E"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#googlePlay_svg__a)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#googlePlay_svg__o"
  })))), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "googlePlay_svg__L"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#googlePlay_svg__a)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#googlePlay_svg__F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "googlePlay_svg__r",
    clipPath: "url(#googlePlay_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.035 55.828H6.965c-3.832 0-6.965-3.14-6.965-6.98V6.98C0 3.14 3.133 0 6.965 0h174.074C184.867 0 188 3.14 188 6.98v41.872c0 3.836-3.133 6.976-6.965 6.976m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "googlePlay_svg__t",
    clipPath: "url(#googlePlay_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.035 1.117c3.227 0 5.852 2.63 5.852 5.863v41.872c0 3.23-2.625 5.863-5.852 5.863H6.965c-3.227 0-5.852-2.633-5.852-5.863V6.98c0-3.234 2.625-5.863 5.852-5.863Zm0-1.117H6.965C3.133 0 0 3.14 0 6.98v41.872c0 3.84 3.133 6.98 6.965 6.98h174.074c3.828 0 6.965-3.14 6.965-6.98V6.98C188 3.14 184.867 0 181.035 0m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#a6a5a5",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "googlePlay_svg__v",
    clipPath: "url(#googlePlay_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.883 30.355c-3.274 0-5.945 2.497-5.945 5.942 0 3.414 2.671 5.933 5.945 5.933 3.277 0 5.949-2.52 5.949-5.933 0-3.445-2.672-5.942-5.95-5.942m0 9.536c-1.793 0-3.344-1.485-3.344-3.594 0-2.14 1.55-3.602 3.344-3.602 1.797 0 3.344 1.461 3.344 3.602.003 2.11-1.547 3.594-3.344 3.594m-12.969-9.536c-3.273 0-5.945 2.497-5.945 5.942 0 3.414 2.668 5.933 5.945 5.933 3.273 0 5.945-2.52 5.945-5.933.004-3.445-2.668-5.942-5.945-5.942m0 9.536c-1.793 0-3.34-1.485-3.34-3.594 0-2.14 1.547-3.602 3.34-3.602 1.797 0 3.344 1.461 3.344 3.602 0 2.11-1.547 3.594-3.344 3.594M66.488 32.18v2.515H72.5c-.18 1.418-.648 2.453-1.367 3.172-.88.88-2.246 1.844-4.645 1.844-3.703 0-6.597-2.988-6.597-6.7 0-3.71 2.89-6.699 6.597-6.699 1.996 0 3.453.786 4.532 1.797l1.77-1.777c-1.505-1.437-3.5-2.539-6.302-2.539-5.07 0-9.336 4.137-9.336 9.219s4.266 9.218 9.336 9.218c2.735 0 4.797-.902 6.414-2.585 1.66-1.665 2.18-4.004 2.18-5.895 0-.582-.047-1.121-.137-1.57Zm63.094 1.957c-.492-1.328-1.996-3.778-5.07-3.778-3.047 0-5.582 2.407-5.582 5.938 0 3.328 2.511 5.937 5.875 5.937 2.715 0 4.285-1.664 4.937-2.632l-2.023-1.348c-.672.988-1.59 1.64-2.914 1.64s-2.266-.605-2.871-1.796l7.918-3.285Zm-8.074 1.976c-.067-2.293 1.773-3.46 3.097-3.46 1.032 0 1.907.515 2.2 1.257Zm-6.442 5.758h2.602v-17.45h-2.602Zm-4.261-10.187h-.09c-.586-.696-1.707-1.329-3.117-1.329-2.965 0-5.676 2.61-5.676 5.961 0 3.329 2.715 5.91 5.676 5.91 1.414 0 2.535-.628 3.117-1.347h.09v.851c0 2.274-1.211 3.489-3.164 3.489-1.594 0-2.582-1.149-2.985-2.114l-2.265.946c.648 1.574 2.379 3.508 5.25 3.508 3.05 0 5.629-1.801 5.629-6.184V30.719h-2.465Zm-2.985 8.207c-1.797 0-3.297-1.504-3.297-3.575 0-2.09 1.5-3.617 3.297-3.617 1.774 0 3.164 1.528 3.164 3.617 0 2.07-1.39 3.575-3.164 3.575m33.953-15.465h-6.222V41.87h2.594v-6.61h3.628c2.883 0 5.711-2.09 5.711-5.417 0-3.332-2.828-5.418-5.71-5.418m.067 8.406h-3.695v-5.98h3.695c1.945 0 3.047 1.613 3.047 2.988 0 1.355-1.102 2.992-3.047 2.992m16.058-2.504c-1.878 0-3.828.832-4.636 2.668l2.308.965c.493-.965 1.414-1.281 2.375-1.281 1.344 0 2.711.808 2.735 2.246v.18c-.473-.27-1.48-.676-2.711-.676-2.485 0-5.016 1.37-5.016 3.93 0 2.335 2.04 3.84 4.32 3.84 1.75 0 2.711-.786 3.317-1.708h.09v1.348h2.507v-6.692c-.003-3.093-2.308-4.82-5.289-4.82m-.308 9.559c-.856 0-2.043-.426-2.043-1.48 0-1.348 1.48-1.86 2.758-1.86 1.14 0 1.68.246 2.375.582-.203 1.617-1.594 2.758-3.09 2.758m14.734-9.18-2.98 7.566h-.09l-3.094-7.566h-2.797L168 41.281l-2.645 5.88h2.711l7.145-16.454Zm-23.406 11.164h2.598V24.426h-2.598Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "googlePlay_svg__x",
    clipPath: "url(#googlePlay_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.852 27.11 14.023 42.878q-.001.006.004.012a4.004 4.004 0 0 0 5.899 2.418l.047-.028 16.691-9.652Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ea4435",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "googlePlay_svg__z",
    clipPath: "url(#googlePlay_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m43.852 24.426-.016-.012-7.203-4.184-8.117 7.239 8.144 8.16 7.164-4.145a4.01 4.01 0 0 0 2.11-3.535 4.01 4.01 0 0 0-2.082-3.523m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#f9bc15",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "googlePlay_svg__B",
    clipPath: "url(#googlePlay_svg__n)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.023 12.945c-.09.332-.136.68-.136 1.035v27.868q.001.539.136 1.03L29.36 27.513Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#547dbf",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "googlePlay_svg__D",
    clipPath: "url(#googlePlay_svg__p)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28.96 27.914 7.673-7.687-16.668-9.688a4 4 0 0 0-2.07-.574 4.015 4.015 0 0 0-3.872 2.98Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#33a851",
      fillOpacity: 1
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "googlePlay_svg__I",
    clipPath: "url(#googlePlay_svg__q)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#googlePlay_svg__r",
    mask: "url(#googlePlay_svg__s)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#googlePlay_svg__t",
    mask: "url(#googlePlay_svg__u)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#googlePlay_svg__v",
    mask: "url(#googlePlay_svg__w)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#googlePlay_svg__x",
    mask: "url(#googlePlay_svg__y)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#googlePlay_svg__z",
    mask: "url(#googlePlay_svg__A)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#googlePlay_svg__B",
    mask: "url(#googlePlay_svg__C)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#googlePlay_svg__D",
    mask: "url(#googlePlay_svg__E)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "googlePlay_svg__K",
    clipPath: "url(#googlePlay_svg__G)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.188 9.637h1.332v3.62h4.058v-3.62h1.324v8.695h-1.324V14.52H59.52v3.812h-1.333ZM67.094 9.637h5.258v1.261h-3.926v2.454h3.539v1.265h-3.54v2.45h3.927v1.265h-5.258ZM74.215 9.637h1.574l3.93 6.386h.07l-.07-1.675V9.637h1.32v8.695h-1.383l-4.117-6.715h-.074l.074 1.676v5.043h-1.324ZM84.84 10.898h-2.434V9.637h6.192v1.261h-2.426v7.434H84.84ZM92.719 9.637h1.332v8.695h-1.332Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "googlePlay_svg__a",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#googlePlay_svg__H)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#googlePlay_svg__I",
    mask: "url(#googlePlay_svg__J)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#googlePlay_svg__K",
    mask: "url(#googlePlay_svg__L)"
  }))));
};
export default SvgGooglePlay;